import MyShipmentsRegisterShipment from './myShipmentsRegisterShipment';

export default MyShipmentsRegisterShipment;
